var _circle, _circle2, _ellipse, _ellipse2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBg1024V1 = function SvgBg1024V1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 900,
    viewBox: "0 0 1024 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1077,
    cy: 751,
    r: 335,
    fill: "#36A9E0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 742.5,
    cy: 754.5,
    r: 114.5,
    fill: "#008FF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: -75.5,
    rx: 307,
    ry: 307.5,
    fill: "#9B51E0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1027,
    cy: 71.5,
    rx: 200,
    ry: 200.5,
    fill: "#FE5F42"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 822,
    cy: -47.5,
    rx: 125,
    ry: 124.5,
    fill: "#F9B233"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -36,
    cy: 248.5,
    rx: 119,
    ry: 119.5,
    fill: "#4D4D4D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBg1024V1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg_1024_v1.de179c0094178068ca9469783187d973.svg";